"use client";

import React from "react";
import styles from "./premium-listing-view.module.css";
import { ListingData } from "@/types/types";
import AgentContactCard from "./components/shared/agent-contact-card";
import MapView from "./components/shared/map-view";
import SimilarProperties from "./components/shared/similar-properties";
import PremiumHero from "./components/premium/premium-hero";
import PremiumDescription from "./components/premium/premium-description";
import PremiumCharacteristics from "./components/premium/premium-characteristics";
import PremiumSaveShare from "./components/premium/premium-save-share";
import PremiumMediaHub from "./components/premium/premium-media-hub";
import TechnicalSpecifications from "./components/shared/technical-specifications";

// Import your shared components as we build them

interface PremiumListingProps {
  listingData: ListingData;
  currency: string;
  unit_system: string;
  locale: string;
}

export default function PremiumListingView({
  listingData,
  currency,
  unit_system,
  locale,
}: PremiumListingProps) {
  return (
    <main className={styles.main}>
      {/* =========================================
          ZONE 1: FULL BLEED CINEMATIC HERO
          ========================================= */}
      <PremiumHero listingData={listingData} />

      {/* =========================================
          ZONE 2: CONSTRAINED CONTENT GRID
          ========================================= */}
      <div className={styles.contentContainer}>
        <div className={styles.layoutGrid}>
          {/* LEFT COLUMN: Main Information */}
          <div className={styles.mainContent}>
            {/* Premium Mini-Gallery */}
            <PremiumMediaHub
              listingData={listingData}
              onOpenGallery={() => console.log("Open Gallery")}
              onOpenVideo={() => console.log("Open Video")}
              onOpenTour={() => console.log("Open Tour")}
              onOpenBrochure={() => console.log("Open Brochure")}
              onOpenFloorPlans={() => console.log("Open Floor Plans")}
            />
            {/* Description & Highlight Icons */}
            <PremiumDescription listingData={listingData} />

            {/* Characteristics Table */}
            <PremiumCharacteristics listingData={listingData} />

            <TechnicalSpecifications listingData={listingData} />
          </div>

          {/* RIGHT COLUMN: Sidebar (Sticky) */}
          <aside className={styles.sidebar}>
            {/* Agent Contact Card (Reusing our shared component with isPremium=true) */}
            <AgentContactCard creator={listingData.creator} isPremium={true} />

            {/* Map & POI Component (Reusing our shared component) */}
            <MapView
              location={listingData.map_location}
              locationOnRequest={listingData.location_on_request}
            />

            {/* Save & Share Action Widget */}
            <PremiumSaveShare
              listingId={listingData.listing_id}
              listingTitle={listingData.title}
            />
          </aside>
        </div>

        {/* BOTTOM SECTION: Similar Properties */}
        <div className={styles.similarProperties}>
          <SimilarProperties listings={listingData.proximity_listings} />
        </div>
      </div>
    </main>
  );
}
